import axios from 'axios';

export const preMaintenanceApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/pre-maintenance`,
    headers: {
        'Content-Type': 'application/json'
    }
})